/**
 * Widget Skeleton Loaders
 * Detects when third-party widgets have rendered content and removes skeleton state
 */
(function() {
  // Klarna skeleton handling
  const initKlarnaSkeleton = () => {
    const klarnaElements = document.querySelectorAll('klarna-placement:not(.loaded)');

    if (!klarnaElements.length) return;

    const markAsLoaded = (element) => {
      // Wait for next animation frames to ensure content is painted
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.classList.add('loaded');
        });
      });
    };

    klarnaElements.forEach((element) => {
      // Check if Klarna has actually rendered content
      // Klarna may use shadow DOM, so check multiple indicators
      const hasKlarnaContent = () => {
        // Check for iframe (might be in light DOM)
        const iframe = element.querySelector('iframe');
        if (iframe && iframe.offsetHeight > 0) return true;

        // Check shadow root if available
        if (element.shadowRoot) {
          const shadowIframe = element.shadowRoot.querySelector('iframe');
          if (shadowIframe && shadowIframe.offsetHeight > 0) return true;
        }

        // Check if element has meaningful children (Klarna rendered)
        const hasChildren = element.children.length > 0 ||
                           (element.shadowRoot && element.shadowRoot.children.length > 0);

        return hasChildren;
      };

      if (hasKlarnaContent()) {
        // Already has content, wait a bit for paint then mark loaded
        setTimeout(() => markAsLoaded(element), 200);
        return;
      }

      // Poll for Klarna content with max timeout
      let attempts = 0;
      const maxAttempts = 100; // 10 seconds max

      const checkForKlarna = () => {
        attempts++;

        if (hasKlarnaContent()) {
          // Content found, wait for full paint
          setTimeout(() => markAsLoaded(element), 300);
        } else if (attempts < maxAttempts) {
          // Keep checking every 100ms
          setTimeout(checkForKlarna, 100);
        }
        // After max attempts, keep skeleton visible (Klarna failed to load)
      };

      // Start checking after initial delay
      setTimeout(checkForKlarna, 300);
    });
  };

  // Bazaarvoice rating summary skeleton handling
  const initBVSkeleton = () => {
    const bvElements = document.querySelectorAll('[data-bv-show="rating_summary"]:not(.loaded)');

    if (!bvElements.length) return;

    bvElements.forEach((element) => {
      // Check if already has star SVGs (content is rendered)
      const hasSvgs = element.querySelector('.bv_stars_component_container svg');
      if (hasSvgs) {
        element.classList.add('loaded');
        return;
      }

      // Use MutationObserver to detect when SVGs are added
      const observer = new MutationObserver(() => {
        const svgs = element.querySelector('.bv_stars_component_container svg');
        if (svgs) {
          element.classList.add('loaded');
          observer.disconnect();
        }
      });

      observer.observe(element, { childList: true, subtree: true });
    });
  };

  const initAllSkeletons = () => {
    initKlarnaSkeleton();
    initBVSkeleton();
  };

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSkeletons);
  } else {
    initAllSkeletons();
  }

  // Also observe for dynamically added elements
  const mutationObserver = new MutationObserver((mutations) => {
    let shouldCheck = false;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.tagName === 'KLARNA-PLACEMENT' ||
              node.hasAttribute?.('data-bv-show') ||
              node.querySelector?.('klarna-placement, [data-bv-show="rating_summary"]')) {
            shouldCheck = true;
          }
        }
      });
    });

    if (shouldCheck) {
      initAllSkeletons();
    }
  });

  if (document.body) {
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
